import { style, keyframes } from '@vanilla-extract/css'

const fade = keyframes({
  '0%': { opacity: 1 },
  '14.28%': { opacity: 1 }, // 1/7
  '18.28%': { opacity: 0 },
  '96%': { opacity: 0 },
  '100%': { opacity: 1 },
})

export const image = style({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  willChange: 'opacity',
  animationName: fade,
  animationDuration: '30s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'ease-out',
})
